import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-skeleton',
  template: '<router-outlet/>',
  imports: [RouterModule],
})
export class AppSkeletonRouterComponent { }
